import { CommonModule } from '@angular/common';
import { ENVIRONMENT_INITIALIZER, inject, NgModule, ValueProvider } from '@angular/core';
import { environment, FAKE_DB_COLLECTIONS_TOKEN } from '@mri-platform/shared/core';
import { ENTITY_METADATA_TOKEN, EntityServices } from '@ngrx/data';
import { entityMetadata, MapperEntityService } from './data-access';
import { devDb } from './testing/dev-dataset';
import { testDb } from './testing/test-dataset';

export const entityStateInitProvider: ValueProvider = {
  provide: ENVIRONMENT_INITIALIZER,
  useValue: () => {
    const entityServices = inject(EntityServices);
    entityServices.registerEntityCollectionServices([inject(MapperEntityService)]);
  },
  multi: true
};

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: ENTITY_METADATA_TOKEN, multi: true, useValue: entityMetadata },
    { provide: FAKE_DB_COLLECTIONS_TOKEN, multi: true, useValue: environment.dev ? devDb : testDb },
    entityStateInitProvider
  ]
})
export class MappersStateModule {}
